import { environment } from '../config/environments/environment';

/**
 * The one place vcon-ui fetches organization branding.
 *
 * Previously two copies of this request existed — an inline fetch in the Sidebar and a helper in
 * transcriptionUtitlityFunctions — which drifted apart in how they handled the response.
 */

export interface OrganizationAppearance {
  organizationId?: string;
  organizationName?: string;
  /** Older responses used these names; kept so existing callers keep working. */
  org_name?: string;
  name?: string;
  logoUrl?: string;
  favicon?: string;
  font?: string;
  primaryColor?: string;
}

const decodeHtmlEntities = (value: string): string => {
  if (!value) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

function normaliseName(data: OrganizationAppearance): OrganizationAppearance {
  const raw = data.organizationName || data.org_name || data.name || '';
  return { ...data, organizationName: decodeHtmlEntities(raw) };
}

async function request(url: string, authToken?: string): Promise<OrganizationAppearance> {
  const response = await fetch(url, {
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch organization appearance: ${response.status}`);
  }

  return normaliseName((await response.json()) as OrganizationAppearance);
}

/** Branding for a known organization. Requires a session. */
export function getOrganizationAppearance(
  organizationId: string,
  authToken?: string
): Promise<OrganizationAppearance> {
  return request(
    `${environment.cmBackendUrl}/api/organization/${organizationId}/appearance`,
    authToken
  );
}
